import { DeviceTemplate } from "./DeviceTemplate";
import { DisplayedChannel } from "./DisplayedChannel"
import { Organization } from "./Organization";

export const defaultDeviceTemplateId = "018f5129-1e73-7000-a3d8-36d144b3b2b8";

export class Device {
    id: string = ""
    serial: string = ""
    displayedChannels: DisplayedChannel[] = [] as DisplayedChannel[];
    organization: Organization | null = null;
    template: DeviceTemplate | null = null;
    metadata?: Record<string, any> = {}
    isOnboarded?: boolean = false
    friendlyName?: string | null = null

    // NxHub firmware status fields
    nxHubTargetFirmwareVersion?: string | null = null
    nxHubCurrentFirmwareVersion?: string | null = null
    nxHubReportedOrgId?: string | null = null
    nxHubUptimeMs?: number | null = null
    nxHubLastBootCode?: string | null = null
    nxHubLastReportTime?: string | null = null
    nxHubVersionTweak?: number | null = null

    // Soft-disabled (lost/retired) marker — null when the device is active. While set,
    // the backend excludes the device from alerts/voice, rejects its uploads, and
    // empties its command poll; check-ins are still accepted so it can be located.
    nxHubDisabledAt?: string | null = null

    // Admin-only opaque hardware-revision label. Only populated for admin users.
    //   hwrev               = admin-authoritative ("what we believe shipped")
    //   nxHubReportedHwrev  = device-observational ("what device most recently said")
    // Drift between the two indicates a PCB swap or jig re-provisioning the admin
    // hasn't acknowledged yet.
    hwrev?: string | null = null
    nxHubReportedHwrev?: string | null = null

    constructor(init?: Partial<Device>) {
        if (!init) {
            return
        }

        Object.assign(this, init)

        if (init.displayedChannels) {
            this.displayedChannels = init.displayedChannels.map(ch => new DisplayedChannel(ch))
        }

        if (init.organization) {
            this.organization = new Organization(init.organization);
        }

        if (init.template) {
            this.template = new DeviceTemplate(init.template);
        }

        if (init.metadata) {
            this.metadata = init.metadata;
        }

        if (init.isOnboarded !== undefined) {
            this.isOnboarded = init.isOnboarded;
        }

        if (init.friendlyName !== undefined) {
            this.friendlyName = init.friendlyName;
        }
    }

    toDataPageUrl() {
        return `/devices/${this.id}`
    }

    get deviceName() {
        switch (this.metadata?.device_type) {
            case "web":
                return "Web";
            case "android":
                return "Android";
            case "ios":
                return "iOS";
            default:
                return "Device";
        }
    }
}
